import React from "react";
import { cn } from "../../lib/helpers";
import * as styles from "./diamond-panel.module.css";

export const DiamondPanel = ({ children, className }) => (
  <div className={cn("relative w-full", className)} style={{ aspectRatio: "1" }}>
    <div
      className={cn("absolute", styles.diamond)}
      style={{
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(45deg)",
        borderRadius: "3rem",
        background: "rgba(0, 0, 0, 0.7)",
        boxShadow: "0 0 80px 20px rgba(255, 255, 255, 0.25)",
      }}
    />
    <div className="absolute inset-0 flex items-center justify-center">
      <div
        className={cn("relative z-10 text-center", styles.content)}
        style={{ textShadow: "0 2px 8px rgba(0, 0, 0, 1)" }}
      >
        {children}
      </div>
    </div>
  </div>
);
